import React, { useEffect, useState, createContext, useContext } from 'react';
import { translations, Language } from '../i18n/translations';
import { sv, enUS } from 'date-fns/locale';
interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: keyof typeof translations.sv) => string;
  dateLocale: typeof sv | typeof enUS;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export const LanguageProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [language, setLanguageState] = useState<Language>('sv');
  useEffect(() => {
    const saved = localStorage.getItem('tnb-lang') as Language;
    if (saved === 'sv' || saved === 'en') {
      setLanguageState(saved);
    }
  }, []);
  const setLanguage = (lang: Language) => {
    setLanguageState(lang);
    localStorage.setItem('tnb-lang', lang);
  };
  const t = (key: keyof typeof translations.sv): string => {
    return translations[language][key] || translations.sv[key] || key;
  };
  const dateLocale = language === 'sv' ? sv : enUS;
  return <LanguageContext.Provider value={{
    language,
    setLanguage,
    t,
    dateLocale
  }} data-id="element-53">
      {children}
    </LanguageContext.Provider>;
};
export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};